import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Box } from "@mui/material";

export default function ExclusivePrescriberFilter({
  setExclusivePrescriber,
  exclusivePrescriber,
  setFilterOptions,
}) {
  const [selectItems, setSelectItems] = React.useState([
    "Exclusive",
    "Non-Exclusive",
    "Both",
  ]);

  const handleChange = (event) => {
    setExclusivePrescriber([event.target.value]);
    setFilterOptions((prev) => ({
      ...prev,
      exclusive_prescriber: event.target.value,
    }));
  };

  return (
    <Box className="filterBar">
      <FormControl sx={{ m: 1, minWidth: 165 }}>
        <InputLabel id="demo-simple-select-autowidth-label">
          Exclusive Prescriber
        </InputLabel>
        <Select
          labelId="demo-simple-select-autowidth-label"
          id="demo-simple-select-autowidth"
          value={exclusivePrescriber}
          onChange={handleChange}
          autoWidth
          label="Exclusive Prescriber"
          placeholder="Exclusive Prescriber"
          sx={{ backgroundColor: "whitesmoke" }}
          style={{ width: 250 }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>

          {selectItems.map((item, index) => {
            return (
              <MenuItem key={index} value={item}>
                {item}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Box>
  );
}
